// Preset tag colors — keys MUST stay in sync with TAG_COLORS in
// backend/routes/client_tags.py (tagColors.test.js asserts the exact list).
// Freeform hex is deliberately not supported, so chips stay on-brand.
// Theme-aware: the /10 tint reads on both light and dark surfaces, and the text
// tone lightens under `dark:`.
export const TAG_COLORS = ['slate', 'red', 'orange', 'amber', 'green', 'teal', 'blue', 'violet'];

const CLASSES = {
  slate:  'bg-slate-500/10 text-slate-600 dark:text-slate-300 border-slate-500/30',
  red:    'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/30',
  orange: 'bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/30',
  amber:  'bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30',
  green:  'bg-green-500/10 text-green-600 dark:text-green-400 border-green-500/30',
  teal:   'bg-teal-500/10 text-teal-600 dark:text-teal-400 border-teal-500/30',
  blue:   'bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/30',
  violet: 'bg-violet-500/10 text-violet-600 dark:text-violet-400 border-violet-500/30',
};

export function tagChipClass(colorKey) {
  return CLASSES[colorKey] || CLASSES.slate;
}
